export default svg => {
  const encoded = svg
    .replace(/\s+/g, " ")
    .replace(/%/g, "%25")
    .replace(/> </g, "><")
    .replace(/; }/g, ";}")
    .replace(/</g, "%3c")
    .replace(/>/g, "%3e")
    .replace(/\"/g, "'")
    .replace(/#/g, "%23")
    .replace(/{/g, "%7b")
    .replace(/}/g, "%7d")
    .replace(/\|/g, "%7c")
    .replace(/\^/g, "%5e")
    .replace(/`/g, "%60")
    .replace(/@/g, "%40");

  return `data:image/svg+xml;charset=UTF-8,${encoded}`;
};
